import React, { useState, useEffect, useRef } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import LabelTag from "../../../reusebale/label";
import ButtonTag from "../../../reusebale/button";
import { Camera, ChevronDown } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import * as DataAction from "../../../../store/actions/data/DataAction";
import BaseUrl from "../../../../constants/BaseUrl";
import AddPropertyPopup from "../../../popup/addPropertyPopup";
import AddUnitPopup from "../../../popup/unitpopup";
import PropertySuccessPopup from "../../../popup/propertySuccess";
import Myloader from "../../../reusebale/myLoader";
import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";
import { GetNotificationMessageByKey } from "../../../../db/NotificationMsgList";
import moment from "moment";

function getDateAfter10Days() {
  const d = new Date();
  d.setDate(d.getDate() + 10);
  return d;
}

const Field = ({ label, children }) => (
  <div>
    <LabelTag isStaric={false} name={label} classes="!text-sm !font-popinsMedium" />
    {children}
  </div>
);

const inputCls = "w-full mt-1 text-sm border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-lg text-darkColor placeholder:text-gray-400 focus:outline-none focus:border-themeColor bg-white";
const selectCls = "w-full mt-1 text-sm border border-gray-300 font-popinsRegular px-3 py-2.5 rounded-lg text-darkColor focus:outline-none focus:border-themeColor bg-white";

const CreateMaintainace = ({ onBack }) => {
  const dispatch = useDispatch();
  const { loginSuccess } = useSelector((state) => state.auth);
  const MaintenanceCategories = useSelector((state) => state.data.maintenanceCategories);

  const [allProperties, setAllProperties] = useState([]);
  const [allUnits, setAllUnits] = useState([]);
  const [showPropertyPopup, setShowPropertyPopup] = useState(false);
  const [showUnitPopup, setShowUnitPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const fileInputRef = useRef(null);

  const [form, setForm] = useState({
    propertyInfo: null,
    unitInfo: null,
    description: "",
    requestCategory: MaintenanceCategories?.[0] || null,
    requestDate: moment().format("YYYY-MM-DD"),
    callerName: "",
    callerPhone: "",
    callerEmail: "",
    techNote: "",
    accessNote: "",
    imageList: [],
    permissionToEnter: false,
  });

  const set = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  // Fetch properties on mount
  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    fetch(`${BaseUrl}api/property/getAllPropertiesbyLandlord/${loginSuccess?.user?._id}?status=active`, { headers: myHeaders })
      .then((r) => r.json())
      .then((result) => { if (result.success) setAllProperties(result.data); })
      .catch(console.error);
  }, []);

  const fetchUnits = (propertyId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    fetch(`${BaseUrl}api/property/getUnitByPropertyId/${propertyId}`, { headers: myHeaders })
      .then((r) => r.json())
      .then((result) => {
        if (result.success) {
          const occupied = (result?.unitData?.unitData || []).filter((u) => u.occupied);
          setAllUnits(occupied);
        }
      })
      .catch(console.error);
  };

  // Autofill caller info from tenant lease when unit is selected
  const autofillCaller = (unit) => {
    if (!unit?.leaseId) return;
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    fetch(`${BaseUrl}api/lease/getLeaseDetails/${unit.leaseId}`, { headers: myHeaders })
      .then((r) => r.json())
      .then((result) => {
        if (result.success && result.data?.tenantInfo) {
          const t = result.data.tenantInfo;
          setForm((prev) => ({
            ...prev,
            callerName: `${t.firstName || ""} ${t.lastName || ""}`.trim(),
            callerPhone: t.cellNo || t.officeNo || "",
            callerEmail: t.email || "",
          }));
        }
      })
      .catch(console.error);
  };

  const uploadImages = (files) => {
    const formdata = new FormData();
    files.forEach((f) => formdata.append("images", f));
    fetch("https://api.dev.theflexmanager.com/api/uploads/upload-multiple", { method: "POST", body: formdata })
      .then((r) => r.json())
      .then((result) => {
        if (result?.files) set("imageList", result.files);
        else ShowError("Upload failed. Use JPEG/PNG under 2MB.");
      })
      .catch(() => ShowError("Upload failed. Use JPEG/PNG under 2MB."));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.propertyInfo || !form.unitInfo || !form.description || !form.requestCategory || !form.requestDate
      || !form.callerName || !form.callerPhone || !form.callerEmail) {
      ShowError("Please fill in all required fields");
      return;
    }

    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      leaseId: form.unitInfo?.leaseId,
      propertyId: form.propertyInfo?._id,
      propertyInfo: form.propertyInfo,
      unitInfo: form.unitInfo,
      description: form.description,
      requestCategory: form.requestCategory,
      requestType: "formField.requestType",
      requestDate: form.requestDate,
      dueDate: form.requestDate,
      proiority: "formField.proiority",
      permissionToEnter: form.permissionToEnter,
      callerInformation: { name: form.callerName, number: form.callerPhone, email: form.callerEmail },
      techNote: form.techNote,
      accessNote: form.accessNote,
      imageList: form.imageList,
    });

    fetch(`${BaseUrl}api/maintenence/createRequest`, { method: "POST", headers: myHeaders, body: raw })
      .then((r) => r.json())
      .then((result) => {
        setLoading(false);
        if (result.status === "success" || result.status === "Success") {
          setShowSuccess(true);
          // Notify
          const notifHeaders = new Headers();
          notifHeaders.append("Content-Type", "application/json");
          notifHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
          fetch(`${BaseUrl}api/notification/createNotification`, {
            method: "POST", headers: notifHeaders,
            body: JSON.stringify({
              landlordId: loginSuccess.user._id,
              title: GetNotificationMessageByKey("maintenance_creation").title,
              description: `${GetNotificationMessageByKey("maintenance_creation").description} ${form.propertyInfo.propertyName}`,
            }),
          }).catch(console.error);
        } else {
          ShowError(result.message);
        }
      })
      .catch(() => { setLoading(false); ShowError("Something went wrong."); });
  };

  return (
    <div className="w-full">
      <div className="flex flex-col justify-center pt-1 mb-4">
        <ParagraphTag content="Maintenance Request" classes="text-darkColor font-popinsSemiBold text-lg" />
        <ParagraphTag content="Create new maintenance request" classes="text-[#686868] font-popinsRegular text-xs" />
      </div>

      <form onSubmit={handleSubmit} className="bg-white rounded-xl p-6 space-y-6">

        {/* ── Section 1: Request Details ── */}
        <div>
          <p className="text-darkColor font-popinsSemiBold text-base mb-4 pb-2 border-b border-gray-100">Request Details</p>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Property">
              <div
                className={`${inputCls} flex justify-between items-center cursor-pointer`}
                onClick={() => setShowPropertyPopup(true)}
              >
                <span className={form.propertyInfo ? "text-darkColor" : "text-gray-400"}>
                  {form.propertyInfo?.propertyName || "Select property"}
                </span>
                <ChevronDown size={16} className="text-gray-400" />
              </div>
            </Field>

            <Field label="Unit">
              <div
                className={`${inputCls} flex justify-between items-center cursor-pointer`}
                onClick={() => form.propertyInfo ? setShowUnitPopup(true) : ShowError("Please select a property first")}
              >
                <span className={form.unitInfo ? "text-darkColor" : "text-gray-400"}>
                  {form.unitInfo?.unitName || "Select unit"}
                </span>
                <ChevronDown size={16} className="text-gray-400" />
              </div>
            </Field>

            <Field label="Request Category">
              <select
                className={selectCls}
                value={form.requestCategory?.category || ""}
                onChange={(e) => {
                  const cat = MaintenanceCategories.find((c) => c.category === e.target.value);
                  set("requestCategory", cat);
                }}
              >
                {MaintenanceCategories?.map((c) => (
                  <option key={c.id} value={c.category}>{c.category}</option>
                ))}
              </select>
            </Field>

            <Field label="Request Date">
              <input
                type="date"
                className={inputCls}
                value={form.requestDate}
                onChange={(e) => set("requestDate", e.target.value)}
              />
            </Field>
          </div>

          <div className="mt-4">
            <Field label="Description">
              <textarea
                rows={3}
                placeholder="Describe the issue..."
                className={`${inputCls} resize-none`}
                value={form.description}
                onChange={(e) => set("description", e.target.value)}
              />
            </Field>
          </div>

          <div className="mt-4">
            <p className="text-sm font-popinsMedium text-darkColor mb-1">Photos</p>
            <div className="flex gap-3 flex-wrap">
              <div
                className="border-dashed border-2 border-gray-300 flex flex-col items-center justify-center w-[90px] h-[90px] bg-gray-50 rounded-lg cursor-pointer hover:border-themeColor"
                onClick={() => fileInputRef.current?.click()}
              >
                <input type="file" multiple accept="image/*" ref={fileInputRef} onChange={(e) => uploadImages(Array.from(e.target.files))} className="hidden" />
                <Camera className="text-gray-400" size={28} strokeWidth={1.5} />
                <p className="text-gray-400 font-popinsRegular text-[10px] mt-1 text-center px-1">Upload</p>
              </div>
              {form.imageList.map((img, i) => (
                <img key={i} src={img?.imageUrl} className="w-[90px] h-[90px] object-cover rounded-lg border border-gray-200" alt="" />
              ))}
            </div>
          </div>
        </div>

        {/* ── Section 2: Caller Info ── */}
        <div>
          <div className="pb-2 border-b border-gray-100 mb-4 flex items-center justify-between">
            <div>
              <p className="text-darkColor font-popinsSemiBold text-base">Caller Info</p>
              <p className="text-gray-400 font-popinsRegular text-xs">In case of urgency, please call this person directly</p>
            </div>
            {form.unitInfo?.leaseId && (
              <button
                type="button"
                onClick={() => autofillCaller(form.unitInfo)}
                className="text-xs text-themeColor border border-themeColor px-3 py-1.5 rounded-lg font-popinsMedium hover:bg-themeColor/5"
              >
                Autofill from Tenant
              </button>
            )}
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Field label="Caller Name">
              <input type="text" className={inputCls} placeholder="Full name" value={form.callerName} onChange={(e) => set("callerName", e.target.value)} />
            </Field>
            <Field label="Caller Phone">
              <input type="text" className={inputCls} placeholder="Phone number" value={form.callerPhone} onChange={(e) => set("callerPhone", e.target.value)} />
            </Field>
            <Field label="Caller Email">
              <input type="text" className={inputCls} placeholder="Email address" value={form.callerEmail} onChange={(e) => set("callerEmail", e.target.value)} />
            </Field>
          </div>
        </div>

        {/* ── Section 3: Notes ── */}
        <div>
          <p className="text-darkColor font-popinsSemiBold text-base mb-1 pb-2 border-b border-gray-100">Notes</p>
          <p className="text-gray-400 font-popinsRegular text-xs mb-4">Write notes for the technician and include any access requirements</p>
          <div className="grid grid-cols-2 gap-4">
            <Field label="Technician Note">
              <textarea rows={4} placeholder="Note for the technician..." className={`${inputCls} resize-none`} value={form.techNote} onChange={(e) => set("techNote", e.target.value)} />
            </Field>
            <Field label="Access Note">
              <textarea rows={4} placeholder="Any access requirements..." className={`${inputCls} resize-none`} value={form.accessNote} onChange={(e) => set("accessNote", e.target.value)} />
            </Field>
          </div>
        </div>

        {/* ── Submit ── */}
        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onBack}
            className="flex-1 py-2.5 rounded-lg border border-gray-300 text-darkColor font-popinsMedium text-sm hover:bg-gray-50"
          >
            Cancel
          </button>
          {loading ? (
            <div className="flex-1 flex justify-center items-center"><Myloader /></div>
          ) : (
            <button
              type="submit"
              className="flex-1 py-2.5 rounded-lg bg-themeColor text-white font-popinsMedium text-sm hover:opacity-90"
            >
              Submit Request
            </button>
          )}
        </div>
      </form>

      {showPropertyPopup && (
        <AddPropertyPopup
          allProperties={allProperties}
          onSelect={(item) => {
            set("propertyInfo", item);
            set("unitInfo", null);
            fetchUnits(item._id);
            setShowPropertyPopup(false);
          }}
          onClose={() => setShowPropertyPopup(false)}
        />
      )}

      {showUnitPopup && (
        <AddUnitPopup
          allUnits={allUnits}
          onClose={() => setShowUnitPopup(false)}
          onSelectUnit={(item) => {
            set("unitInfo", item);
            setShowUnitPopup(false);
            autofillCaller(item);
          }}
        />
      )}

      {showSuccess && (
        <PropertySuccessPopup
          succMessage="Maintenance request created successfully"
          onClose={() => { setShowSuccess(false); onBack(); dispatch(DataAction.ChangeMaintenanceCurrentStep(1)); }}
        />
      )}
    </div>
  );
};

export default CreateMaintainace;
